export const DEFAULT_MONITORING_ROTATION_INTERVAL_SEC = 5;

/** 시설 단위 전체화면 롤링 기본 간격(초) — CCTV 개별 순환과 분리 */
export const DEFAULT_MONITORING_POOL_GRID_ROTATION_INTERVAL_SEC = 20;

export function readMonitoringRotationIntervalSec(): number {
  const raw = parseInt(localStorage.getItem('monitoringRotationIntervalSec') || '5', 10);
  if (!Number.isFinite(raw)) return DEFAULT_MONITORING_ROTATION_INTERVAL_SEC;
  return Math.min(300, Math.max(1, raw));
}

export function writeMonitoringRotationIntervalSec(sec: number): void {
  const n = Math.min(300, Math.max(1, Math.floor(sec)));
  try {
    localStorage.setItem('monitoringRotationIntervalSec', String(n));
  } catch {
    /* ignore */
  }
}

/** 시설 전체화면(grid) 롤링 간격 */
export function readMonitoringPoolGridRotationIntervalSec(): number {
  const raw = parseInt(
    localStorage.getItem('monitoringPoolGridRotationIntervalSec') || '',
    10
  );
  if (!Number.isFinite(raw)) return DEFAULT_MONITORING_POOL_GRID_ROTATION_INTERVAL_SEC;
  return Math.min(300, Math.max(1, raw));
}

export function writeMonitoringPoolGridRotationIntervalSec(sec: number): void {
  const n = Math.min(300, Math.max(1, Math.floor(sec)));
  try {
    localStorage.setItem('monitoringPoolGridRotationIntervalSec', String(n));
  } catch {
    /* ignore */
  }
}
